/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FantaTeamPatch = {
    properties: {
        name: {
            type: 'any-of',
            contains: [{
                type: 'string',
            }, {
                type: 'null',
            }],
        },
        jerseyColor1: {
            type: 'any-of',
            contains: [{
                type: 'string',
                maxLength: 7,
                minLength: 7,
                pattern: '^#[0-9A-Fa-f]{6}$',
            }, {
                type: 'null',
            }],
        },
        jerseyColor2: {
            type: 'any-of',
            contains: [{
                type: 'string',
                maxLength: 7,
                minLength: 7,
                pattern: '^#[0-9A-Fa-f]{6}$',
            }, {
                type: 'null',
            }],
        },
        jerseyMode: {
            type: 'any-of',
            contains: [{
                type: 'JerseyModeEnum',
            }, {
                type: 'null',
            }],
        },
    },
} as const;
